export class CostaRicaRequestedInfo {    
    cedNumber: string = '';

    constructor(jsonObject: any = null) {
        if (jsonObject !== null) {
            if (jsonObject instanceof CostaRicaRequestedInfo) {               
                this.cedNumber = jsonObject.cedNumber;
            }  else {
                // this is a json object let's deserialize it
                if (jsonObject.hasOwnProperty('attributes') && jsonObject.attributes instanceof Array) {
                    jsonObject.attributes.forEach( (property : any) => {
                        if (property.name === "COSTA RICA IDENTIFICATION NUMBER") {
                            this.cedNumber = property.value;
                        }
                    });
                }              
            }
        }
    }
}
